<ng-select
    [disabled]="isDisabled"
    [items]="allCategories"
    [(ngModel)]="selectedCategory"
    [ngModelOptions]="{ standalone: true }"
    (change)="categoryChanged()"
    [clearable]="false"
    appendTo="body"
    [searchFn]="searchInName"
    bindLabel="Name"
>
</ng-select>
